/**
 * @generated SignedSource<<3dae70845bd687a41f1fa3a09a7461f9>>
 * @relayHash 323b4708c921b4390cda5d42e5653f96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331

import type { ConcreteRequest } from 'relay-runtime';
export type fetchNativeCollabConfluenceUsersQuery$variables = {
  accountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type fetchNativeCollabConfluenceUsersQuery$data = {
  readonly confluenceUsers: {
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly isDefault: boolean | null | undefined;
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type fetchNativeCollabConfluenceUsersQuery = {
  response: fetchNativeCollabConfluenceUsersQuery$data;
  variables: fetchNativeCollabConfluenceUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isDefault"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "RELATIVE"
        }
      ],
      "kind": "ScalarField",
      "name": "path",
      "storageKey": "path(type:\"RELATIVE\")"
    }
  ]
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "KnownUser"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnknownUser"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchNativeCollabConfluenceUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchNativeCollabConfluenceUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "323b4708c921b4390cda5d42e5653f96",
    "id": "36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331",
    "metadata": {},
    "name": "fetchNativeCollabConfluenceUsersQuery",
    "operationKind": "query",
    "text": "query fetchNativeCollabConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,profilePicture{isDefault,path(type:RELATIVE)},...on KnownUser{accountId},...on UnknownUser{accountId},displayName}}}"
  }
};
})();

(node as any).hash = "e9ca85d4f438ea6a9fa558a7a23119a8";

export default node;
